module.exports = __webpack_public_path__ + "static/media/cheques.cfb05cde.svg";